<template>
    <div :class="['row', 'section', cssClass]">
        <div class="col-12 col-md-3 col-lg-2 col-lg-offset-1 col-xl-offset-2">
            <div class="title">
                <slot name="title"></slot>
            </div>
        </div>
        <div class="col-12 col-md-8 col-lg-7 col-xl-5">
            <div class="content">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
            name: 'ProfileSettingsSection',
            props: {
                cssClass: {
                    type: String
                },
            }
    }
</script>